"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavItemSup = exports.XLargeTextPlaceholdler = exports.LargeTextPlaceholdler = exports.MediumTextPlaceholdler = exports.SearchPlaceholdler = exports.SmallTextPlaceholdler = exports.expandLine = exports.StyledNavItem = exports.StyledList = exports.StyledNav = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const styles_1 = require("../skeleton/styles");
exports.StyledNav = styled_components_1.default.nav `
  position: relative;

  box-sizing: border-box;

  height: 48px;

  color: ${({ theme }) => theme.colors.text.body};

  transition: all ease 100ms;

  @media screen and (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    height: 48px;
  }
`;
exports.StyledList = styled_components_1.default.ul `
  display: flex;

  justify-content: ${({ isOverflowing }) => (isOverflowing ? 'left' : 'center')};

  align-items: center;
  overflow-x: scroll;

  padding: ${({ theme }) => theme.space.s200};

  white-space: nowrap;

  list-style-type: none;

  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }

  /* Mobile */
  @media screen and (max-width: calc(${({ theme }) => theme.breakpoint.tablet} - 1px)) {
    ${({ isTransparent }) => !isTransparent &&
    (0, styled_components_1.css) `
        padding-top: 0;
      `}
  }

  /* Desktop */
  @media screen and (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
    ${({ isTransparent }) => isTransparent &&
    (0, styled_components_1.css) `
        padding-top: ${({ theme }) => theme.space.s300};
        padding-bottom: ${({ theme }) => theme.space.s300};
      `}
  }
`;
const activeItemStyles = ({ isTransparent }) => (0, styled_components_1.css) `
  background: ${({ theme }) => theme.colors.white.s100};

  color: inherit;

  ${!isTransparent &&
    (0, styled_components_1.css) `
    box-shadow: inset 0 0 0 2px;
  `}
`;
exports.StyledNavItem = styled_components_1.default.li `
  display: flex;

  flex-shrink: 0;

  margin: 0 ${({ theme }) => theme.space.s050};

  :first-child {
    margin-left: 0;
  }

  :last-child {
    margin-right: 0;
  }

  > a {
    align-items: center;

    padding: ${({ theme }) => theme.space.s100} ${({ theme }) => theme.space.s200};

    background: rgba(255, 255, 255, 0.7);

    color: inherit;

    border-radius: 62.5rem;

    box-shadow: inset 0 0 0 1px ${({ isTransparent, theme }) => (isTransparent ? theme.colors.white.s100 : theme.colors.gray.s300)};

    ${({ isSelected }) => isSelected &&
    (0, styled_components_1.css) `
        ${activeItemStyles}
      `}

    transition-duration: 0.3s;

    transition-property: background-color;

    &:hover,
    &:active,
    &:focus {
      ${activeItemStyles}
    }
  }

  /* Desktop */
  @media screen and (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
    margin: 0 ${({ theme }) => theme.space.s100};

    > a {
      ${({ isSelected }) => isSelected && (0, styled_components_1.css) ``}
    }
  }
`;
exports.expandLine = (0, styled_components_1.keyframes) `
  from {
    transform: scaleX(0);
  }

  to {
    transform: scaleX(1);
  }
`;
const basePlaceholderStyle = (0, styled_components_1.css) `
  background-color: ${({ theme }) => theme.colors.gray.s300};

  border-radius: 48px;

  ${styles_1.skeletonAnimation}
`;
exports.SmallTextPlaceholdler = styled_components_1.default.span `
  display: inline-flex;
  align-self: center;
  width: 42px;

  height: 16px;
  margin-right: ${({ theme }) => theme.space.s150};
  margin-left: ${({ theme }) => theme.space.s150};

  ${basePlaceholderStyle};
`;
exports.SearchPlaceholdler = styled_components_1.default.span `
  display: inline-flex;
  align-self: end;
  width: 720px;
  height: 40px;
  margin-right: ${({ theme }) => theme.space.s150};
  margin-left: ${({ theme }) => theme.space.s150};

  ${basePlaceholderStyle};
`;
exports.MediumTextPlaceholdler = (0, styled_components_1.default)(exports.SmallTextPlaceholdler) `
  width: 58px;
`;
exports.LargeTextPlaceholdler = (0, styled_components_1.default)(exports.SmallTextPlaceholdler) `
  width: 120px;
`;
exports.XLargeTextPlaceholdler = (0, styled_components_1.default)(exports.SmallTextPlaceholdler) `
  width: 148px;
`;
exports.NavItemSup = styled_components_1.default.sup `
  margin: 0 0 ${({ theme }) => theme.space.s150} ${({ theme }) => theme.space.s050};

  font-style: italic;

  ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.tinyTextMain)};
  ${({ isSelected }) => isSelected &&
    (0, styled_components_1.css) `
      font-weight: bold;
    `};
  ${({ isPrimary }) => isPrimary &&
    (0, styled_components_1.css) `
      color: ${({ theme }) => theme.colors.main.base};
    `};
`;
